module.exports = __webpack_public_path__ + "img/icon_eden_configuration.8443361d.svg";